import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { RestService } from 'app/shared/rest.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'environments/environment';
import { AuthService } from 'app/shared/auth.service';
import { EnrollSessionService } from 'app/shared/enrollSession.service';
import { SharedMethodService } from 'app/shared/sharedMethod.service';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { MatDialog } from '@angular/material/dialog';
import { CoreSectionPopupDialogComponent } from './powerShakePopup/powerShakePopup.component';
import * as moment from 'moment';
import * as _ from 'underscore';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { SubscriptionTextPopupDialogComponent } from './subscriptionTextBox-dialog/subscriptionTextpopup-popup-dialog.component';
import { IMAGE_URL } from 'app/constants';
import { uploadImageVedioService } from 'app/shared/uploadImageVedio.service';

const dynamicScripts = [
  'assets/js/webflow.js'
  ];
  
@Component({
  selector: 'app-ultlifestyle',
  templateUrl: './ultlifestyle.component.html',
  styleUrls: ['./ultlifestyle.component.scss']
})
export class UltlifestyleComponent implements OnInit {
  IMAGE_URL = IMAGE_URL;
  @ViewChild('slickModal', { static: false }) slickModal: SlickCarouselComponent;
  @ViewChild('slickModal1', { static: false }) slickModal1: SlickCarouselComponent;
  @ViewChild('slickModal2', { static: false }) slickModal2: SlickCarouselComponent;
  public slideConfig = {
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 1,
    "adaptiveHeight": false,
    "autoplay": false,
    "autoplaySpeed": 5000,
    "dir": 'ltr',
    "arrows": false
  };
  public slideConfig2 = {
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 3,
    "adaptiveHeight": false,
    "autoplay": true,
    "slidesToScroll": 3,
    "autoplaySpeed": 5000,
    "dir": 'ltr',
    "arrows": false
  };
  public slideConfig1 = {
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "adaptiveHeight": false,
    "autoplay": true,
    "autoplaySpeed": 5000,
    "dir": 'ltr',
    "arrows": false
  };
  
  ultPacks: any;
  showPack: any;
  slideIndex: any = 0;
  slides: any;
  data: any;
  webAliasData: any;
  dots: any;
  BucketUrl = environment.BucketURl;
  mobileView: any;
  meetDaveVideos = {};
  coreProducts = {};
  SubscribeProducts = [];
  SubscribeProduct = {};
  dialogRef: any;
  customerReview: any;
  customerReviewImage: any;
  customerReviewVideo: any;
  ratingCount = 5;
  rating = 1;
  reviews: any;
  addImage: boolean = false;
  addVideo: boolean = false;
  reviewSection: { [key: string]: boolean } = {};
  reviewList: any;
  anchors: any;
  anchorsReview: any;
  itemJudgmeRes: any;
  item: any;
  ultImage: any;
  ultLongDetail: any;
  ultLongDetail3: any;
  ultLongDetail4: any;
  toggleMonth1: boolean = false;
  toggleMonth2: boolean = false;
  toggleMonth3: boolean = false;
  toggleMonth4: boolean = false;
  ulttoggle: boolean = false;
  ulttoggle2: boolean = false;
  ulttoggle3: boolean = false;
  ulttoggle4: boolean = false;
  ulttoggle5: boolean = false;
  ulttoggle6: boolean = false;
  ultproductsInfoStates: boolean[] = [false, false, false, false, false, false];
  ultlabelInfoStates: boolean[] = [false, false, false, false, false, false];
  ultlearnMoreStates: boolean[] = [false, false, false, false, false, false];
  ultcustomerReviews: boolean = false;
  ultcustomerReviews2: boolean = false;
  ultcustomerReviews3: boolean = false;
  ultcustomerReviews4: boolean = false;
  ultcustomerReviews5: boolean = false;
  ultcustomerReviews6: boolean = false;
  ULTLifestyleProducts: any;
  ULTDarkBerryProducts: any;
  ULTPerformanceProducts: any;
  ULTImmuneProducts: any;
  ULTCOllagenSupportProducts: any;
  ULTBrainProducts: any;
  YourPrice: any;
  RetailPrices: any;
  customerReviewForms: FormGroup;
  ReviewsExternalID: any;
  reviewMediaFile: any = [];
 @ViewChildren('ReviewElement11240,ReviewElement11280,ReviewElement11241,ReviewElement11242,ReviewElement11243,ReviewElement11248') ReviewElement: QueryList<ElementRef>;
 @ViewChildren('ReviewElement11240Mobile,ReviewElement11280Mobile,ReviewElement11241Mobile,ReviewElement11242Mobile,ReviewElement11243Mobile,ReviewElement11248Mobile') ReviewElementMobile: QueryList<ElementRef>;
  constructor(
    private _restService: RestService,
    private _http: HttpClient,
      private _toastr: ToastrService,
      private router: Router,
      private _renderer2: Renderer2,
      public _auth: AuthService,
      public _sharedMethodService: SharedMethodService, 
      public _enrollSession: EnrollSessionService,
      private _matDialog: MatDialog,
      @Inject(DOCUMENT) private _document: Document,
      private _formBuilder: FormBuilder,
      private uploadImageVedioService: uploadImageVedioService
  ) { 
    this.customerReviewForms = this.createCustomerReviewForm();
  }

  ngOnInit(): void {
    this.setDynamicBackground();
    this.getULTProduct(504)
    .then(() => this.getULTProduct(655))
    .then(() => this.getULTProduct(644))
    .then(() => this.getULTProduct(510))
    .then(() => this.getULTProduct(509))
    .then(() => this.getULTProduct(508))
    this.showPack=1;
    this.reviewCarousel();
    let screenWidth = window.innerWidth
      if (screenWidth < 550) {
        this.mobileView = true;
      }
      else {
        this.mobileView = false;
      }
      
    const script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
      script.text = `
      {
          "@context": "https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=340136345"
      }
    `;
    script.async = true;
    script.defer = true;
    this._renderer2.appendChild(this._document.body, script);

    this.ultPacks = [{
      'id': 1,
      'image': `${IMAGE_URL}/images/ultlifestyleLanding/PowerShakeAppleBerryPouch.png`,
      'details': 
        {
          'text1': 'Energy Levels',
          'text2': 'Cravings',
          'text3': 'Detoxify Cells',
          'text4': 'Satisfy Hunger',    
          'text5': 'Burn Fat',
        }
    },
    {
      'id': 2,
      'image': `${IMAGE_URL}/images/ultlifestyleLanding/SuperAmino.png`,
      'details': 
        {
          'text1': 'Create Lean Muscle',
          'text2': 'Burn Fat',
          'text3': 'Elasticity (tighten skin)',
          'text4': 'Mental Function',
          'text5': '',
        }
    },
    {
      'id': 3,
      'image': `${IMAGE_URL}/images/ultlifestyleLanding/Biome_Medic.png`,
      'details': 
        {
          'text1': 'Detoxify Glyphosate',
          'text2': 'Digestion',
          'text3': 'Bloating',
          'text4': 'Immunity',
          'text5': 'Healthy C-Reactive Protein Levels',
        }
    },
    {
      'id': 4,
      'image': `${IMAGE_URL}/images/ultlifestyleLanding/OrganicCherryNew.png`,
      'details': 
        {
          'text1': 'Deepen Sleep',
          'text2': 'Combat Free Radical Damage',
          'text3': 'Healthy Skin',
          'text4': 'Healthy Inflammatory Response',
          'text5': '',
        }
    },
    {
      'id': 5,
      'image': `${IMAGE_URL}/images/ultlifestyleLanding/SuperCleansR_1.png`,
      'details': 
        {
          'text1': 'Healthy bowel function',
          'text2': 'Release toxins and build up',
          'text3': 'Elimination of parasites'
        }
    }
    ]
    document.getElementById("ult").style.display = "flex";
    document.getElementById("ult_immune").style.display = "none";  
    document.getElementById("ult_collagen").style.display = "none";    
    document.getElementById("ult_performance").style.display = "none";
    document.getElementById("ult_darkberry").style.display = "none";

    document.getElementById("pane-A").style.display = "flex";
    document.getElementById("pane-B").style.display = "none";  
    document.getElementById("pane-C").style.display = "none";  
   

    window.onclick = function(event) {
      if (event.target == document.getElementById("myModal")) {
        document.getElementById("myModal").style.display = "none";
      }
      if (event.target == document.getElementById("UltimateLifestyleModal")) {
        document.getElementById("UltimateLifestyleModal").style.display = "none";
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    var SSOToken = urlParams.get('SSOToken');
    this.webAliasData = urlParams.get('giftcard') || sessionStorage.getItem('giftCardName');
    if (SSOToken) {
      window.localStorage.setItem('SSOToken', urlParams.get('SSOToken'));
      urlParams.delete('SSOToken');
      window.location.href = window.location.origin + window.location.pathname;
    }
    else {
      SSOToken = window.localStorage.getItem('SSOToken');
    }
    setTimeout(()=>{
    },10000);

    this.meetDaveVideos = [
        { url: 'https://player.vimeo.com/video/884136301?loop=1&muted=1', titles: 'Introducing Purium’s 90-Day Lifestyle Subscription' },
        { url: 'https://player.vimeo.com/video/870473644?loop=1&muted=1', titles: 'Purium’s Ultimate Lifestyle Transformation' }
    ];
    this.coreProducts = [
      {id:1,heading: 'Power Shake', description: 'Nourishing Greens' , imageUrl: `${IMAGE_URL}/images/ultlifestyleLanding/PowerShakeAppleBerryPouch.png`, star: `${IMAGE_URL}/images/ultlifestyleLanding/green_Star.png`, reviews: "“Love this shake! I absolutely love this green shake! It's often <br *ngIf='!_enrollSession.mobileViewMethod()'> the first thing I consume in the morning, and it makes me feel <br *ngIf='!_enrollSession.mobileViewMethod()'> great! It's so delicious and nourishing, I love it with oat milk, <br *ngIf='!_enrollSession.mobileViewMethod()'> makes it extra creamy and tasty.” – Sarah Hughes"},
      {id:3,heading: 'Biome Medic', description: `<span>Supports a Healthy <br> Gut Microbiome<span>` , imageUrl: `${IMAGE_URL}/images/ultlifestyleLanding/Biome_Medic.png`, star: `${IMAGE_URL}/images/ultlifestyleLanding/yellow_Star.png`, reviews: "“Daily Essential. Introduced to Purium over one year ago. <br *ngIf='!_enrollSession.mobileViewMethod()'> Biome Medic is essential to maintain my gut health and <br *ngIf='!_enrollSession.mobileViewMethod()'> continue my transformation results. I love the way I feel, <br *ngIf='!_enrollSession.mobileViewMethod()'> and I make sure to keep my stock full!” – Sherryl L Bellafiore"},
      {id:2,heading: 'Super Amino 23', description: 'Build Lean <br> Muscle' , imageUrl: `${IMAGE_URL}/images/ultlifestyleLanding/SuperAmino.png`, star: `${IMAGE_URL}/images/ultlifestyleLanding/lightGreen_Star.png`, reviews: "“The energy of the aminos is next level. <br *ngIf='!_enrollSession.mobileViewMethod()'> Love the super aminos for energy, takes brain fog <br *ngIf='!_enrollSession.mobileViewMethod()'> away and helps me focus.” – Luciano Errico"},
      {id:4,heading: 'Apothe-cherry', description: 'Anti-Aging Sleep <br> Support' , imageUrl: `${IMAGE_URL}/images/ultlifestyleLanding/OrganicCherryNew.png`, star: `${IMAGE_URL}/images/ultlifestyleLanding/red_Star.png`, reviews: "“Amazing! I LOVE apothe cherry!! Not only is cherry <br *ngIf='!_enrollSession.mobileViewMethod()'> my fav since forever, apothe has helped me sleep <br *ngIf='!_enrollSession.mobileViewMethod()'> better than anything I've tried in the past! I'm <br *ngIf='!_enrollSession.mobileViewMethod()'> seriously hooked!” – Melanie Conrad"},
      {id:5,heading: 'Super CleansR', description: 'Parasite Cleanse' , imageUrl: `${IMAGE_URL}/images/ultlifestyleLanding/SuperCleansR_1.png`, star: `${IMAGE_URL}/images/ultlifestyleLanding/black_Star.png`, reviews: "“Best cleanse on the market <br *ngIf='!_enrollSession.mobileViewMethod()'> I love Super Cleanse R and use it every time I need <br *ngIf='!_enrollSession.mobileViewMethod()'> to reset my body.” – Kathy Alpers"},
    ];
    
  }

  setDynamicBackground(): void {
    const imageUrl1 = `${IMAGE_URL}/images/ultlifestyleLanding/gettyImage.jpg`;
    const imageUrl2 = `${IMAGE_URL}/images/ultlifestyleLanding/RectangleGreen.png`;
    const imageUrl3 = `${IMAGE_URL}/images/ultlifestyleLanding/RectangleBlue.png`;
    const imageUrl4 = `${IMAGE_URL}/images/ultlifestyleLanding/RectanglePurple.png`;
    const imageUrl5 = `${IMAGE_URL}/images/ultlifestyleLanding/RectangleOrange.png`;
    const imageUrl6 = `${IMAGE_URL}/images/ultlifestyleLanding/Check-Icon.svg`;
    const imageUrl7 = `${IMAGE_URL}/images/ultlifestyleLanding/gImage.jpg`;
    const imageUrl8 = `${IMAGE_URL}/icons/stars/star-full.png`;
    const imageUrl9 = `${IMAGE_URL}/icons/stars/star-blank.png`;
    const imageUrl10 = `${IMAGE_URL}/icons/stars/star-half.png`;

    document.documentElement.style.setProperty('--image-base-url1', `url(${imageUrl1})`);
    document.documentElement.style.setProperty('--image-base-url2', `url(${imageUrl2})`);
    document.documentElement.style.setProperty('--image-base-url3', `url(${imageUrl3})`);
    document.documentElement.style.setProperty('--image-base-url4', `url(${imageUrl4})`);
    document.documentElement.style.setProperty('--image-base-url5', `url(${imageUrl5})`);
    document.documentElement.style.setProperty('--image-base-url6', `url(${imageUrl6})`);
    document.documentElement.style.setProperty('--image-base-url7', `url(${imageUrl7})`);
    document.documentElement.style.setProperty('--image-base-url8', `url(${imageUrl8})`);
    document.documentElement.style.setProperty('--image-base-url9', `url(${imageUrl9})`);
    document.documentElement.style.setProperty('--image-base-url10', `url(${imageUrl10})`);
  }
  next() {
    this.slickModal.slickNext();
  }
  prev() {
    this.slickModal.slickPrev();
  }
  nextCore() {
    this.slickModal1.slickNext();
  }
  prevCore() {
    this.slickModal1.slickPrev();
  }
  nextSubscribe() {
    this.slickModal2.slickNext();
  }
  prevSubscribe() {
    this.slickModal2.slickPrev();
  }
  getColors(index?){
  var bannersCss = this.SubscribeProducts;
  if(index === 0){
    $('#Subscribeheading0').css('color', bannersCss[0].color);
    $('#border-box-slick0').css('border', '1px solid '+ bannersCss[0].color);
    $('#product_section_get_button0').css('background-color',bannersCss[0].color);
  }
  if(index === 1){
    $('#Subscribeheading1').css('color', bannersCss[1].color);
    $('#border-box-slick1').css('border', '1px solid '+ bannersCss[1].color);
    $('#product_section_get_button1').css('background-color',bannersCss[1].color);
  }
  if(index === 2){
    $('#Subscribeheading2').css('color', bannersCss[2].color);
    $('#border-box-slick2').css('border', '1px solid '+  bannersCss[2].color);
    $('#product_section_get_button2').css('background-color',bannersCss[2].color);
  }
  if(index === 3){
    $('#Subscribeheading3').css('color', bannersCss[3].color);
    $('#border-box-slick3').css('border', '1px solid '+  bannersCss[3].color);
    $('#product_section_get_button3').css('background-color',bannersCss[3].color);
  }
  if(index === 4){
    $('#Subscribeheading4').css('color', bannersCss[4].color);
    $('#border-box-slick4').css('border', '1px solid '+ bannersCss[4].color);
    $('#product_section_get_button4').css('background-color',bannersCss[4].color);
  }
  if(index === 5){
    $('#Subscribeheading5').css('color', bannersCss[5].color);
    $('#border-box-slick5').css('border', '1px solid '+ bannersCss[5].color);
    $('#product_section_get_button5').css('background-color',bannersCss[5].color);
  }
  }
  packType(id) {
    const tabColors = {
      1: "#749472",
      2: "#A33FA3",
      3: "#F99F27",
      4: "#056FB6",
      5: "#164BD3",
      6: "#550855"
    };
    const productInfo = {
      1: { judgMeProduct: '11200', image: '11240', detail: '11240', price: '11240', section: 11 },
      2: { judgMeProduct: '11235', image: '11243', detail: '11243', price: '11243', section: 17 },
      3: { judgMeProduct: '11208', image: '11242', detail: '11242', price: '11242', section: 20 },
      4: { judgMeProduct: '11210', image: '11241', detail: '11241', price: '11241', section: 23 },
      5: { judgMeProduct: '11270', image: '11248', detail: '11248', price: '11248', section: 14 },
      6: { judgMeProduct: '11280', image: '11280', detail: '11280', price: '11280', section: 26 }
    };
    const displaySections = {
      1: ["ult", "flex", ["ult_collagen", "ult_immune", "ult_performance", "ult_brain", "ult_darkberry"]],
      2: ["ult_collagen", "flex", ["ult", "ult_immune", "ult_performance", "ult_brain", "ult_darkberry"]],
      3: ["ult_immune", "flex", ["ult", "ult_collagen", "ult_performance", "ult_brain", "ult_darkberry"]],
      4: ["ult_performance", "flex", ["ult", "ult_collagen", "ult_immune", "ult_brain", "ult_darkberry"]],
      5: ["ult_brain", "flex", ["ult", "ult_collagen", "ult_immune", "ult_performance", "ult_darkberry"]],
      6: ["ult_darkberry", "flex", ["ult", "ult_collagen", "ult_immune", "ult_performance", "ult_brain"]]
    };
    this.showPack = id;
    // Reset tab styles for all other tabs
    [1, 2, 3, 4, 5, 6].forEach((tabId) => {
      const elem = document.getElementById(tabId.toString());
      if (tabId === id) {
        elem.style.background = tabColors[id];
        elem.style.color = "#fff";
      } else {
        elem.style.background = "none";
        elem.style.color = "#000";
      }
    });
  
    // Update styles based on the selected tab
    const selectedColor = tabColors[id];
    $('.ult-lifestyle-transformation-text').css('color', selectedColor);
    $('.product_section_get_button1').css('background-color', selectedColor);
  
    // Update product section display
    const [toShow, displayStyle, toHide] = displaySections[id];
    document.getElementById(toShow).style.display = displayStyle;
    toHide.forEach(section => document.getElementById(section).style.display = "none");
  
    // Update product information
    const { judgMeProduct, image, detail, price, section } = productInfo[id];
    this.GetAllJudgMeProducts(judgMeProduct);
    this.productImage(image);
    this.LongDetail(detail);
    this.productsPrices(price);
    this.productSectionInfo(section, selectedColor);
  }
  productSectionInfo(id, colorCode?) {
    const sections = {
      11: { color: colorCode || "#749472", panes: ["pane-A", "pane-B", "pane-C"], siblings: [12, 13] },
      12: { color: colorCode || "#749472", panes: ["pane-B", "pane-A", "pane-C"], siblings: [11, 13] },
      13: { color: colorCode || "#749472", panes: ["pane-C", "pane-A", "pane-B"], siblings: [11, 12] },
      14: { color: colorCode || "#164BD3", panes: ["pane-D", "pane-E", "pane-F"], siblings: [15, 16] },
      15: { color: colorCode || "#164BD3", panes: ["pane-E", "pane-D", "pane-F"], siblings: [14, 16] },
      16: { color: colorCode || "#164BD3", panes: ["pane-F", "pane-D", "pane-E"], siblings: [14, 15] },
      17: { color: colorCode || "#A33FA3", panes: ["pane-G", "pane-H", "pane-I"], siblings: [18, 19] },
      18: { color: colorCode || "#A33FA3", panes: ["pane-H", "pane-G", "pane-I"], siblings: [17, 19] },
      19: { color: colorCode || "#A33FA3", panes: ["pane-I", "pane-G", "pane-H"], siblings: [17, 18] },
      20: { color: colorCode || "#F99F27", panes: ["pane-J", "pane-K", "pane-L"], siblings: [21, 22] },
      21: { color: colorCode || "#F99F27", panes: ["pane-K", "pane-J", "pane-L"], siblings: [20, 22] },
      22: { color: colorCode || "#F99F27", panes: ["pane-L", "pane-J", "pane-K"], siblings: [20, 21] },
      23: { color: colorCode || "#056FB6", panes: ["pane-M", "pane-N", "pane-O"], siblings: [24, 25] },
      24: { color: colorCode || "#056FB6", panes: ["pane-N", "pane-M", "pane-O"], siblings: [23, 25] },
      25: { color: colorCode || "#056FB6", panes: ["pane-O", "pane-M", "pane-N"], siblings: [23, 24] },
      26: { color: colorCode || "#550855", panes: ["pane-P", "pane-Q", "pane-R"], siblings: [27, 28] },
      27: { color: colorCode || "#550855", panes: ["pane-Q", "pane-P", "pane-R"], siblings: [26, 28] },
      28: { color: colorCode || "#550855", panes: ["pane-R", "pane-P", "pane-Q"], siblings: [26, 27] }
    };
    const section = sections[id];
    if (!section) return;
    section.siblings.forEach(siblingId => {
      const elem = document.getElementById(siblingId.toString());
      if (elem) {
        elem.style.background = "none";
        elem.style.color = "#000";
      }
    });
    const currentElem = document.getElementById(id);
    if (currentElem) {
      currentElem.style.backgroundColor = section.color;
      currentElem.style.color = "#fff";
    }
    $(`#${section.panes[0]}`).css("display", "flex");
    $(`#${section.panes[1]}`).css("display", "none");
    $(`#${section.panes[2]}`).css("display", "none");
  }
  openCoreSection(id){
  this.data='';
  this.ultPacks.filter((item) => {
    if (item.id == id) {
      this.data = item;
      return;
    }
  });
  this.CoreSectionInfoPopup(this.data,id);
  }
  CoreSectionInfoPopup(data:any,id:any){
    this.dialogRef = this._matDialog.open(CoreSectionPopupDialogComponent, {
        width: '80%',
        maxWidth: '80%',
        height: '250px',
        disableClose: true,
        data: [data,id]
    });
    this.dialogRef.afterClosed()
        .subscribe(response => {
  
        });
  }
  SubscriptionTextPopup(){
    this.dialogRef = this._matDialog.open(SubscriptionTextPopupDialogComponent, {
        width: '80%',
        maxWidth: '80%',
        height: '250px',
        disableClose: true,
    });
    this.dialogRef.afterClosed()
        .subscribe(response => {
  
        });
  }
  openModel(id) {
  this.data='';
  this.ultPacks.filter((item) => {
    if (item.id == id) {
      this.data = item;
      return;
    }
  })
  document.getElementById("myModal").style.display = "block";
  if(document.getElementById('product')){
    document.getElementById('product').remove();
  };
  var html = '';
  html += '<div id="product-popup" style="display:flex">';
  html += '<div id="product">';
  html +=  '<div style="position: relative;width: 80%">'
  switch(id) {
    case 1:
      html += '<p style="text-align: center;font-size: 30px;color: #3A5838;font-weight: 500;margin:0;">Power Shake</p>';
      html += '<p style=" text-align: center;font-size: 20px;font-weight: 500;font-style: italic;">Nourishing Greens</p>';
      html += '<img src="' + this.data.image + '" loading="lazy" alt="image" class="icons" style="width:50%">';
      // html += '<img class="ult-pc-grass1" src=IMAGE_URL+"/images/ultlifestyleLanding/Grass.png" alt="absol-image" loading="lazy" alt="image" style="width:50%">';
      break;
    case 2:
      html += '<img src="' + this.data.image + '" loading="lazy" alt="image" class="icons" style="width:50%;position: absolute;z-index: 999;">';
      html += '<img class="superaminoBg" src=IMAGE_URL+"/images/ultlifestyleLanding/superaminoBgIcon.png" alt="absol-image" loading="lazy" alt="image" style="width: 40%;position: absolute;margin-top: 70px;margin-right: 115px;z-index: 888;">';
      break;
    case 3:
      html += '<img src="' + this.data.image + '" loading="lazy" alt="image" class="icons" style="width:50%;position: absolute;">';
      html += '<img class="biomeBgBottom" src=IMAGE_URL+"/images/ultlifestyleLanding/biomeBgBottom1.png" alt="absol-image" loading="lazy" alt="image" style="width: 34%;position: absolute;margin-left: 188px;margin-top: 101px;">';
      break;
    case 4:
      html += '<img src="' + this.data.image + '" loading="lazy" alt="image" class="icons" style="width:50%">';
      html += '<img class="TartCherries1" src=IMAGE_URL+"/images/ultlifestyleLanding/TartCherries.png" alt="absol-image" loading="lazy" alt="image" style="width:50%">';
      break;
    case 5:
      html += '<img src="' + this.data.image + '" loading="lazy" alt="image" class="icons" style="width:50%">';
      html += '';
      break;
    default:
      // code block
  }
  html += '</div>'
  html += '<div style="padding:50px 50px 15px 50px;border-radius: 30px; text-align: start;" class="cursor-pointer">';
  html += '<h5 class="dialog-section">May Help:</h5>';
  html += '<ul class="dialog-box">';
  html += '<li>' + this.data.details.text1 + '</li>';
  html += '<li>' + this.data.details.text2 + '</li>';
  html += '<li>' + this.data.details.text3 + '</li>';
  this.data.details.text4 && (html += '<li>' + this.data.details.text4 + '</li>');
  if(this.data.details.text5){
    html += '<li>' + this.data.details.text5 + '</li>';
  }  
  html += '</ul>';
  html += '</div>';
  html += '</div>';
  html +=  '<div style="position: relative;width: 80%">';
  switch(id) {
    case 1:
      html += '<img src=IMAGE_URL+"/images/ultlifestyleLanding/PowerShakePopupImage.png" loading="lazy" alt="image" class="icons" style="width:50%">';
      break;
    case 2:
      html += '<img src="" loading="lazy" alt="image" class="icons" style="width:50%;position: absolute;z-index: 999;">';
      break;
    case 3:
      html += '<img src="" loading="lazy" alt="image" class="icons" style="width:50%;position: absolute;">';
      break;
    case 4:
      html += '<img src="" loading="lazy" alt="image" class="icons" style="width:50%">';
      break;
    case 5:
      html += '<img src="" loading="lazy" alt="image" class="icons" style="width:50%">';
      break;
    default:
      // code block
  }
  html += '</div>';
  html += '</div>';
  document.getElementById('add_after_me').insertAdjacentHTML("afterend", html);
  }
  UltimateLifestyleModal() {
    document.getElementById("UltimateLifestyleModal").style.display = "block";
  }
  
  close()
  {
    document.getElementById('myModal').style.display='none';
  }

  BuyNowToday(itemcode) {
    var queryString = window.localStorage.getItem('SSOToken') ? ("&SSOToken=" + encodeURIComponent(window.localStorage.getItem('SSOToken'))+(this.webAliasData? "&giftcard="+this.webAliasData : '')+"&site=ultlifestyle&itemcode="+ itemcode) : (this.webAliasData? "?site=ultlifestyle&itemcode="+ itemcode+"&giftcard="+this.webAliasData : "?site=ultlifestyle&itemcode="+ itemcode) ;  
    this.router.navigateByUrl('/OrderReview'+queryString);
  }
  
  packSelected(itemcode) {
    this.BuyNowToday(itemcode);
  }
    
  reviewCarousel() {
  let i;
  this.slides = document.getElementsByClassName("review-cards");
  this.dots = document.getElementsByClassName("dot");
  for (i = 0; i < this.slides.length; i++) {
    this.slides[i].style.display = "none";  
  }
  this.slideIndex++;
  if (this.slideIndex > this.slides.length) {this.slideIndex = 1}    
  for (i = 0; i < this.dots.length; i++) {
    this.dots[i].className =  this.dots[i].className.replace(" active-dot", "");
  }
  if(this.slides[this.slideIndex-1] && this.dots[this.slideIndex-1]){
    this.slides[this.slideIndex-1].style.display = "flex";  
    this.dots[this.slideIndex-1].className += " active-dot";
  }
  
  setTimeout(this.reviewCarousel, 30000); // Change image every 30 seconds
  }
  loadScript() {
    console.log('preparing to load…')
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text / javascript';
      node.async = false;
      node.charset = 'utf - 8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
  RedirectToUltLifestyle() {
    this.router.navigateByUrl('/Ultlifestyle');
  }

  RedirectToShopNow() {
    const shopNowRedirect = document.querySelector('#shopNowRedirect') as HTMLElement;
    if (shopNowRedirect) {
      const scrollPositionAbove = shopNowRedirect.offsetTop; 
      window.scrollTo({ top: scrollPositionAbove, behavior: 'smooth' });
    }
    return;
  }
  ClickToRedirectStartToday() {
    const startFirst = document.querySelector('#startFirst') as HTMLElement;
    if (startFirst) {
      const scrollPositionAbove = startFirst.offsetTop; 
      window.scrollTo({ top: scrollPositionAbove, behavior: 'smooth' });
    }
    setTimeout(() => {
      const startToday = document.querySelector('#startToday') as HTMLElement;
      if (startToday) {
        const scrollPositionAbove = startToday.offsetTop; 
        window.scrollTo({ top: scrollPositionAbove, behavior: 'smooth' });
      }
    }, 600);
  }
  handleReview(handle, itemcode) {
    const reviewHandler = (element) => {
      const observer = new MutationObserver(() => {
        this.anchors = element.nativeElement.querySelectorAll('.jdgm-paginate__page');
        this.anchors.forEach((anchor: HTMLAnchorElement) => {
          anchor.addEventListener('click', ($event: any) => {
            this.getReviews(handle, $event.target.dataset.page, itemcode);
          });
        });
      });
  
      observer.observe(element.nativeElement, { childList: true, subtree: true });
    };
  
    if (this._enrollSession.mobileViewMethod()) {
      this.ReviewElementMobile.forEach((element, index) => {
        reviewHandler(element);
      });
    } else {
      this.ReviewElement.forEach((element, index) => {
        reviewHandler(element);
      });
    }
  }
  GetAllJudgMeProducts(itemcode) {
    this._restService.GetAllJudgMeProducts().subscribe((items: any) => {
      items.forEach((item) => {
        if (item.ItemCode == itemcode) {
          this.ReviewsExternalID = item.ExternalId;
          this.getReviews(item.Handle, 1, itemcode);
          this.handleReview(item.Handle,itemcode);
          this.itemJudgmeRes = item;
        }
        else {
          this.reviewList = '';
          this.reviews = '';
        }
      })
    })
  }
  createCustomerReviewForm() {
    return this._formBuilder.group({
        Name: ['', Validators.required],
        Email: ['', [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/)]],
        ReviewTitle: ['', Validators.required],
        WriteYourComment: ['', Validators.required],
        reviewPicture: [''],
        reviewVideo: ['']
    })
  }
  convertSpecialCharacters(text) {
    return text.replace(/â€™/g, "'")
              .replace(/â€˜/g, "'")
              .replace(/â€œ/g, '"')
              .replace(/â€/g, '"')
              .replace(/â€¦/g, '...')
              .replace(/â€“/g, '-')
              .replace(/â€¢/g, '*')
              .replace(/â€/g, '•')
              .replace(/â€º/g, '›')
              .replace(/â€º/g, '‹')
              .replace(/ðŸ™/g, '🙏')
              .replace(/ðŸ¥°/g, '😰')
              .replace(/ðŸ¦‹/g, '🦋')
              .replace(/ðŸ¿/g, '🏿')
              .replace(/ðŸŒ¿/g,'🌿')
              .replace(/ðŸ™Œ/g,'🙌')
              .replace(/ðŸ¼/g,' 🏽')
              .replace(/ðŸ’£/g,'💣')
              .replace(/â¤ï¸/g,'❤️')
              .replace(/ðŸ¼/g,'👍🏻')
              .replace(/â™¥ï¸/g,'♥️')
              .replace(/ðŸ’š/g,'💖')
                   .replace(/ðŸ¶/g,'🐶')
                   .replace(/ðŸ’™/g,'💙')
                   .replace(/ðŸ•/g,'🐕')
                   .replace(/ðŸ’¯/g,'💯');
  }
  getReviews(product, page, itemCode?) {
    let a = product.split(' ');
    let b = a.join('-');
    let externalID = this.ReviewsExternalID;
    this._restService.JudgeMeReviews(b, page).subscribe((res: any) => {
      if(res.product_external_id === externalID){
        let c = res.widget.split("data-number-of-reviews='");
        let d = c[1].split("'");
        this.reviews = d[0];
        let responseHtml = res?.widget;
        responseHtml = responseHtml.replaceAll("data-src", "src")

        if (responseHtml) {
          this.reviewList = this.convertSpecialCharacters(responseHtml);
          var _self = this;
          this.waitForElement('jdgm-write-rev-link', function () { _self.writeCustomerReview(itemCode) });
          this.waitForElement('jdgm-rev__timestamp', function () { _self.addTimestamp() });
        }
      }
    })
  }
  waitForElement(classname, callback) {
    var poops = setInterval(function () {
        if (document.getElementsByClassName(classname)) {
            clearInterval(poops);
            callback();
        }
    }, 1000);
  }
  addTimestamp() {
    if (this._enrollSession.mobileViewMethod()) {
      this.ReviewElementMobile.forEach((element, index) => {
        const momentDate = element.nativeElement.getElementsByClassName('jdgm-rev__timestamp');
        _.each(momentDate, (ele) => {
          let date = ele.dataset.content; let momentObj = moment(date, 'YYYY-MM-DD HH:mm:ss UTC');
          if (momentObj.isValid()) {
            let monthNumber = momentObj.month() + 1;
            let dayNumber = momentObj.date();
            let year = momentObj.year();
            let month = monthNumber < 10 ? '0' + monthNumber : monthNumber;
            let day = dayNumber < 10 ? '0' + dayNumber : dayNumber;
            ele.innerHTML = `${month}/${day}/${year}`;
          }
          else { console.error('Invalid date format:', date); }
        });
      });
    }
    else {
      this.ReviewElement.forEach((element, index) => {
        const momentDate = element.nativeElement.getElementsByClassName('jdgm-rev__timestamp');
        _.each(momentDate, (ele) => {
          let date = ele.dataset.content; let momentObj = moment(date, 'YYYY-MM-DD HH:mm:ss UTC');
          if (momentObj.isValid()) {
            let monthNumber = momentObj.month() + 1;
            let dayNumber = momentObj.date();
            let year = momentObj.year();
            let month = monthNumber < 10 ? '0' + monthNumber : monthNumber;
            let day = dayNumber < 10 ? '0' + dayNumber : dayNumber;
            ele.innerHTML = `${month}/${day}/${year}`;
          }
          else { console.error('Invalid date format:', date); }
        });
      });
    }

  }
  addReviewPicture(event, type) {
    try {
    const file: File = event.target.files[0];
    if (file) {
      this.uploadImageVedioService.uploadFile(file,type).subscribe(event => {
          let result = JSON.stringify(event);
          let resultBody = JSON.parse(result);
          this.reviewMediaFile.push(resultBody.secure_url);
          if(this.reviewMediaFile.length !== 0) {
            if (type == 'picture') {
                this.customerReviewImage = file.name;
                this.addImage = true;
            } else if (type == 'video') {
                this.customerReviewVideo = file.name;
                this.addVideo = true;
            }
        }
          /*if (event['type'] === HttpEventType.UploadProgress) {
          } else if (event instanceof HttpResponse) {
            if (type == 'picture') {
              this.customerReviewImage = file.name;
              this.addImage = true;
            } else if (type == 'video') {
              this.customerReviewVideo = file.name;
              this.addVideo = true;
            }
          }*/
        },
        err => {
          this._toastr.error(err);
        });
    }
   }catch(error) {
    console.log(error);
   }
  }
  pathName(itemCode) {
    let index;
    let path;
    let reviewFormId;
    let mobileViewPath;
    let reviewFormIDMobile;
    let pathArray = {
      index, path, reviewFormId, mobileViewPath, reviewFormIDMobile
    }
    switch (itemCode) {
      case ('11200'):
        pathArray = {
          index: 0,
          path: "ult",
          reviewFormId: 'ult_11200',
          mobileViewPath: 'collapseULT',
          reviewFormIDMobile: 'ult_11200Mobile'
        }
        break;
      case ('11280'):
        pathArray = {
          index: 1,
          path: "ult_darkberry",
          reviewFormId: 'ult_11280',
          mobileViewPath: 'collapseULTDarkBerry',
          reviewFormIDMobile: 'ult_11280Mobile'
        }
        break;
      case ('11270'):
        pathArray = {
          index: 2,
          path: "ult_brain",
          reviewFormId: 'ult_11248',
          mobileViewPath: 'collapseULTBrain',
          reviewFormIDMobile: 'ult_11248Mobile'
        }
        break;
      case ('11208'):
        pathArray = {
          index: 3,
          path: "ult_immune",
          reviewFormId: 'ult_11208',
          mobileViewPath: 'collapseULTImmune',
          reviewFormIDMobile: 'ult_11208Mobile'
        }
        break;
      case ('11235'):
        pathArray = {
          index: 4,
          path: "ult_collagen",
          reviewFormId: 'ult_11235',
          mobileViewPath: 'collapseULTCollagen',
          reviewFormIDMobile: 'ult_11235Mobile'
        }
        break;
      case ('11210'):
        pathArray = {
          index: 5,
          path: "ult_performance",
          reviewFormId: 'ult_11210',
          mobileViewPath: 'collapseULTPerformance',
          reviewFormIDMobile: 'ult_11210Mobile'
        }
        break;
      default:
    }
    return pathArray;
  }
  writeCustomerReview(itemCode) {
    this.reviewSection[itemCode] = false;
    let pathName = this.pathName(itemCode);
    if(this._enrollSession.mobileViewMethod()){
      this.anchorsReview = document.getElementById(pathName.mobileViewPath);
    }
    else{
      this.anchorsReview = document.getElementById(pathName.path);
    }
    this.anchorsReview?.getElementsByClassName('jdgm-write-rev-link')[0]?.removeAttribute('href');
    this.anchorsReview?.getElementsByClassName('jdgm-write-rev-link')[0]?.setAttribute('display', 'block');
    this.anchorsReview?.getElementsByClassName('jdgm-write-rev-link')[0]?.setAttribute('id', itemCode);
    var _this = this;
    this.reviewMediaFile = [];
    this.addVideo = false;
    this.addImage = false;
    $(_this.anchorsReview).on("click", "#" + itemCode, (event) => {
      _this.reviewSection[itemCode] = true;
      if (sessionStorage.getItem('CustomerReviewMessage')) {
        _this.customerReviewForms.patchValue({
          Name: '',
          Email: '',
          ReviewTitle: '',
          WriteYourComment: '',
          reviewPicture: '',
          reviewVideo: '',
          YoutubeURL: ''
        });
      }
      setTimeout(() => {
        if (_this.reviewSection[itemCode]) {
          let element;
          if(this._enrollSession.mobileViewMethod()){
            element = document.getElementById(pathName.reviewFormIDMobile);
          }
          else{
            element = document.getElementById(pathName.reviewFormId);
          }
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
          }
        }
      },1000)
    });
  }
  submitReview(itemCode) {
    this.customerReview = this.customerReviewForms.value;
    if (this.customerReviewForms.invalid) {
        this._toastr.error('Please field the required');
        return this.validateAllFormFields(this.customerReviewForms);
    }
    const request = {
        "shop_domain": "puriumreviews.com",
        "platform": "woocommerce",
        "id": this.itemJudgmeRes.ExternalId,
        "email": this.customerReview.Email,
        "name": this.customerReview.Name,
        "reviewer_name_format": "",
        "rating": this.rating,
        "title": this.customerReview.ReviewTitle,
        "body": this.customerReview.WriteYourComment,
        "cf_answers": [{ "cf_question_id": 0, "value": "" }],
        "picture_urls": this.reviewMediaFile,
        "ip_addr": ""
    }
    this._restService.CreateProductReview(request).subscribe({
        next: (result) => {
            this.reviewSection[itemCode] = false;
            sessionStorage.setItem('CustomerReviewMessage', result['message']);
            this.reviewMediaFile = [];
            this._toastr.info(result['message']);
        }, error: (error) => {
            console.log('error', error);
        },
        complete: () => {
        }
    })
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
        }
    });
  }
  productsImage(itemCode) {
    const productCategories = {
      '11240': this.ULTLifestyleProducts,
      '11280': this.ULTDarkBerryProducts,
      '11241': this.ULTPerformanceProducts,
      '11242': this.ULTImmuneProducts,
      '11243': this.ULTCOllagenSupportProducts,
      '11248': this.ULTBrainProducts
    };
  
    const productList = productCategories[itemCode];
    if (productList) {
      const product = productList.find(item => item.ItemCode === itemCode);
      return product?.SmallPicture;
    }
    return null;
  }
  productImage(itemCode?) {
    const productCategories = {
      '11240': this.ULTLifestyleProducts,
      '11280': this.ULTDarkBerryProducts,
      '11241': this.ULTPerformanceProducts,
      '11242': this.ULTImmuneProducts,
      '11243': this.ULTCOllagenSupportProducts,
      '11248': this.ULTBrainProducts
    };
  
    const productList = productCategories[itemCode];
    if (productList) {
      this.ultImage = productList.find(item => item.ItemCode === itemCode)?.SmallPicture;
    }
  }
  productsPrices(itemCode) {
    const productCategories = {
      '11240': this.ULTLifestyleProducts,
      '11280': this.ULTDarkBerryProducts,
      '11241': this.ULTPerformanceProducts,
      '11242': this.ULTImmuneProducts,
      '11243': this.ULTCOllagenSupportProducts,
      '11248': this.ULTBrainProducts
    };
  
    const productList = productCategories[itemCode];
    if (productList) {
      const product = productList.find(item => item.ItemCode === itemCode);
      if (product) {
        this.YourPrice = product.Price;
        this.RetailPrices = product.Other1Price;
      }
    }
  }
  LongDetail(itemCode) {
    const productCategories = {
      '11240': this.ULTLifestyleProducts,
      '11280': this.ULTDarkBerryProducts,
      '11241': this.ULTPerformanceProducts,
      '11242': this.ULTImmuneProducts,
      '11243': this.ULTCOllagenSupportProducts,
      '11248': this.ULTBrainProducts
    };
  
    const productList = productCategories[itemCode];
    if (productList) {
      const product = productList.find(item => item.ItemCode === itemCode);
      if (product) {
        this.ultLongDetail = product.LongDetail;
        this.ultLongDetail3 = product.LongDetail3;
        this.ultLongDetail4 = product.LongDetail4;
      }
    }
  }
  ClickToOpenToggleMonth(id: number) {
    const toggleMonths = [this.toggleMonth1, this.toggleMonth2, this.toggleMonth3, this.toggleMonth4];
    toggleMonths.forEach((_, index) => {
      toggleMonths[index] = (id === index + 1) ? !toggleMonths[index] : false;
    });
    [this.toggleMonth1, this.toggleMonth2, this.toggleMonth3, this.toggleMonth4] = toggleMonths;
  }
  ClickToOpenULT(id) {
    const ultMap = {
      1: { toggle: 'ulttoggle', productId: '11240', bgClass: 'bg-ult1', headingClass: 'headingTextult1', bgColor: '#749472', textColor: '#ffffff' },
      2: { toggle: 'ulttoggle2', productId: '11248', bgClass: 'bg-ult2', headingClass: 'headingTextult2', bgColor: '#1C4BC0', textColor: '#ffffff' },
      3: { toggle: 'ulttoggle3', productId: '11243', bgClass: 'bg-ult3', headingClass: 'headingTextult3', bgColor: '#A33FA3', textColor: '#ffffff' },
      4: { toggle: 'ulttoggle4', productId: '11242', bgClass: 'bg-ult4', headingClass: 'headingTextult4', bgColor: '#BF8A56', textColor: '#ffffff' },
      5: { toggle: 'ulttoggle5', productId: '11241', bgClass: 'bg-ult5', headingClass: 'headingTextult5', bgColor: '#53A3D7', textColor: '#ffffff' },
      6: { toggle: 'ulttoggle6', productId: '11280', bgClass: 'bg-ult6', headingClass: 'headingTextult6', bgColor: '#550855', textColor: '#ffffff' },
    };

    const selectedULT = ultMap[id];

    if (selectedULT) {
      const currentToggleState = this[selectedULT.toggle];
      this[selectedULT.toggle] = !currentToggleState;

      // Reset other toggles
      Object.keys(ultMap).forEach(key => {
        if (parseInt(key) !== id) {
          this[ultMap[key].toggle] = false;
        }
      });

      // Reset customer reviews
      this.ultcustomerReviews = false;
      this.ultcustomerReviews2 = false;
      this.ultcustomerReviews3 = false;
      this.ultcustomerReviews4 = false;
      this.ultcustomerReviews5 = false;
      this.ultcustomerReviews6 = false;

      if (!currentToggleState) {
        this.productImage(selectedULT.productId);
        this.LongDetail(selectedULT.productId);
        this.productsPrices(selectedULT.productId);
        this.GetAllJudgMeProducts(selectedULT.productId);

        // Update UI
        $(`.${selectedULT.bgClass}`).css('background-color', selectedULT.bgColor);
        $(`.${selectedULT.headingClass}`).css('color', selectedULT.textColor);

        // Reset other UI elements
        Object.keys(ultMap).forEach(key => {
          if (parseInt(key) !== id) {
            $(`.${ultMap[key].bgClass}`).css('background-color', '#E5E3E3');
            $(`.${ultMap[key].headingClass}`).css('color', ultMap[key].bgColor);
          }
        });

        setTimeout(() => {
          const element = document.getElementById(`collapseULT${id}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 1000);
      } else {
        $(`.${selectedULT.bgClass}`).css('background-color', '#E5E3E3');
        $(`.${selectedULT.headingClass}`).css('color', selectedULT.bgColor);
      }
    }
  }
  ClickToOpenULTProductsInfo(id: number): void {
    this.ultproductsInfoStates[id - 1] = !this.ultproductsInfoStates[id - 1];
  }
  ClickToOpenULTLabelInfo(id: number): void {
    this.ultlabelInfoStates[id - 1] = !this.ultlabelInfoStates[id - 1];
  }
  ClickToOpenULTLearnMore(id: number): void {
    this.ultlearnMoreStates[id - 1] = !this.ultlearnMoreStates[id - 1];
  }
  ClickToOpenULTCustomerReviews(id) {
    const reviewsMap = {
      1: { state: 'ultcustomerReviews', productId: '11200' },
      2: { state: 'ultcustomerReviews2', productId: '11270' },
      3: { state: 'ultcustomerReviews3', productId: '11235' },
      4: { state: 'ultcustomerReviews4', productId: '11208' },
      5: { state: 'ultcustomerReviews5', productId: '11210' },
      6: { state: 'ultcustomerReviews6', productId: '11200' },
    };
    const reviewState = reviewsMap[id];
    if (reviewState) {
      const currentState = this[reviewState.state];
      this[reviewState.state] = !currentState;
      
      if (!currentState) {
        this.GetAllJudgMeProducts(reviewState.productId);
      }
    }
  }
  getULTProduct(webCategoryId): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = {
        'EnrollmentType': '',
        'CustomerType': 22,
        'WebCategoryId': webCategoryId,
        'isUpgradeCustomer': false
      };
  
      this._restService.getProducts(request).subscribe((res: any) => {
        switch (webCategoryId) {
          case 504:
            this.ULTLifestyleProducts = res.Items;
            this.loadInitialItems();
            this.ultPackCarousel(11240);
            localStorage.setItem('ULTLifestyleProducts', JSON.stringify(this.ULTLifestyleProducts));
            break;
          case 644:
            this.ULTBrainProducts = res.Items;
            localStorage.setItem('ULTBrainProducts', JSON.stringify(this.ULTBrainProducts));
            this.ultPackCarousel(11248);
            break;
          case 510:
            this.ULTCOllagenSupportProducts = res.Items;
            localStorage.setItem('ULTCOllagenSupportProducts', JSON.stringify(this.ULTCOllagenSupportProducts));
            this.ultPackCarousel(11243);
            break;
          case 509:
            this.ULTImmuneProducts = res.Items;
            localStorage.setItem('ULTImmuneProducts', JSON.stringify(this.ULTImmuneProducts));
            this.ultPackCarousel(11242);
            break;
          case 508:
            this.ULTPerformanceProducts = res.Items;
            localStorage.setItem('ULTPerformanceProducts', JSON.stringify(this.ULTPerformanceProducts));
            this.ultPackCarousel(11241);
            break;
          case 655:
            this.ULTDarkBerryProducts = res.Items;
            localStorage.setItem('ULTDarkBerryProducts', JSON.stringify(this.ULTDarkBerryProducts));
            this.ultPackCarousel(11280);
            break;
        }
        resolve();
      }, (error) => {
        reject(error);
      });
    });
  }
  loadInitialItems() {
    this.productImage('11240');
    this.LongDetail('11240');
    this.productSectionInfo(11, '#749472');
    this.productsPrices('11240');
    this.packType(1);
  }
  ultPackCarousel(itemCode)
  {
    switch(itemCode) {
      case 11240:
        this.SubscribeProduct = {id: 11240, sortBy:0, heading: 'Ultimate Lifestyle<br> Transformation (ULT)',imageUrl:  this.productsImage('11240'),color:  '#749472',newpackLogo: '', starURL: `${IMAGE_URL}/images/ultlifestyleLanding/green_Star.png`, reviewText: '“6 months ago I decided to make a change! No more excuses and no more waiting for the perfect day. I have found that nutrition partnered with just moving my body has changed my life...”'};
        break;
      case 11280:
        this.SubscribeProduct = {id: 11280, sortBy:1, heading: 'ULT +<br>Dark Berry Protein',imageUrl:  this.productsImage('11280'),color:  '#550855',newpackLogo: '',starURL: `${IMAGE_URL}/images/ultlifestyleLanding/brown_Star.png`,reviewText: "“Super product! I love this Dark Berry protein shake—it's refreshing and makes a great addition to my healthy lifestyle.”"}
        break;
      case 11248:
        this.SubscribeProduct = {id: 11248, sortBy:2, heading: 'ULT +<br>Brain',imageUrl:  this.productsImage('11248'),color:  '#1C4BC0',newpackLogo: `${IMAGE_URL}/images/ultlifestyleLanding/newPack_logo.png`,starURL: `${IMAGE_URL}/images/ultlifestyleLanding/blue_star.png`,reviewText: "“I'm absolutely thrilled to commence this journey with the Ult + Brain Pack, dedicated to enhancing my cognitive health and unlocking boundless potential for both my body and mind. Remarkably, within just a few days of starting, I've noticed a significant surge in my attention to detail.”"};
        break;
      case 11243:
        this.SubscribeProduct = {id: 11243, sortBy:3, heading: 'ULT +<br>Collagen Support',imageUrl:  this.productsImage('11243'),color:  '#A33FA3',newpackLogo: '',starURL: `${IMAGE_URL}/images/ultlifestyleLanding/pink_Star.png`,reviewText: '“Wowwww this pack is amazing ! Highly recommand ! My skin is glowing, everyone around me is asking me what is my secret!..”'};
        break;
      case 11242:
        this.SubscribeProduct = {id: 11242, sortBy:4, heading: 'ULT +<br>Immune',imageUrl:  this.productsImage('11242'),color:  '#BF8A56',newpackLogo: '',starURL: `${IMAGE_URL}/images/ultlifestyleLanding/sandColor_Star.png`,reviewText: '“This is so so essential for my health as someone who has a genetic mutation preventing my body from creating many antibodies and white blood cells. I must support my immune system in all other ways that I can!”'}
        break;
      case 11241:
        this.SubscribeProduct = {id: 11241, sortBy:5, heading: 'ULT +<br>Performance',imageUrl:  this.productsImage('11241'),color:  '#53A3D7',newpackLogo: '',starURL: `${IMAGE_URL}/images/ultlifestyleLanding/lightBlue_Star.png`,reviewText: '“I’ve been healthy and active the past 30 years of my life but getting on the ULT + performance kit really took my mental and physical health to a level I never could have dreamed of...”'}
        break;
      default:
        return;
    }
    this.SubscribeProducts.push(this.SubscribeProduct);
    this.getColors(0);
  }

  navigateToCollection2() {
    this.router.navigate(['/Collection2']);
  }
}